import { Component } from '@angular/core';
import { NavParams, ModalController } from 'ionic-angular';

import { PessoalService } from '../../../../providers/pessoal-service';
import { MenuService } from '../../../../providers/menu-service';

import { ModulosController } from '../../modulos-controller';
import { UsuarioService } from '../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { AlertService } from '../../../../providers/alert-service';
import { CargoService } from '../../../../providers/cargo-service';
import { ModalNaoSeAplicaPage } from "../../../modais/nao-se-aplica/modal-nao-se-aplica";

import { ModalPreVisualizarPessoalPage } from '../../../modais/modal-pre-visualizacao/pessoal/modal-pv-pessoal';

@Component({
  selector: 'page-resumo-analise',
  templateUrl: 'resumo-analise.html',
  providers: [
    PessoalService
  ]
})
export class PessoalResumoAnalisePage extends ModulosController {
  listaAnalises: any[];
  listaCargos: any[];
  loading: boolean = true;
  // isJurisdicionado: boolean;
  usuario: any;

  constructor(private pessoalService: PessoalService,
    public alertService: AlertService, public usuarioService: UsuarioService,
    public modalCtrl: ModalController, public navParams: NavParams, public CargoService: CargoService,
    public gestaoPcaService: GestaoPcaService, public menuService: MenuService) {
    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);
    this.carregarDados();

    // this.usuario = usuarioService.obtemUsuario();
    // if (this.usuario != undefined) {
    //   this.isJurisdicionado = this.usuarioService.isJurisdicionado();
    // }
    this.setModuloId(11)
  }

  carregarDados() {
    if (!this.isJurisdicionado) {
      this.pessoalService.obterListaAnalises(this.pessoalService.codigoModuloPessoal).subscribe(data => {
        this.listaAnalises = data;

        this.listaAnalises.forEach(x => {
          if (x.idStatusAnalise == 5 || x.idStatusAnalise == 6 || x.idStatusAnalise == 7) {
            x.idStatusAnalise = 11;
            x.dsStatusAnalise = 'Para Consulta';
          }
        });

        this.setIdModuloPca(this.listaAnalises[0].idModuloPca);
        this.loading = false;
      }, error => {
        console.log("erro: " + error.mensagem);
        this.loading = false;
      });
    } else {
      this.pessoalService.obterListaAnalisesJur(this.pessoalService.codigoModuloPessoal).subscribe(data => {
        this.listaAnalises = data;
        this.loading = false;
      }, error => {
        console.log("erro: " + error.mensagem);
        this.loading = false;
      });

      this.CargoService.listarCargoAtivo(11).subscribe(data => {
        this.listaCargos = data;
      }, error => console.log("erro: " + error));
    }
  }

  redirecionarParaAnalise(analise) {

    if (analise.cdAnalise == '109' || analise.cdAnalise == '108' || this.listaCargos == undefined || this.listaCargos.length > 0) {

      analise.cdModulo = this.pessoalService.obterIdPaginaPessoal();
      this.menuService.redirecionarSubPagina(this.pessoalService.obterIdPaginaPessoal(), analise);

    } else {
      this.alertService.mostraAlerta("", "Necessário cadastrar pelo menos um cargo ativo no item 'Relação de Cargos'.");
    }
  }

  voltarPCA() {
    let idSecaoPaginaGestaoPCA = '964';

    this.menuService.redirecionarPagina(idSecaoPaginaGestaoPCA);
  }

  naoSeAplica() {

    this.gestaoPcaService.obterModuloPcaPorPCAPorModulo(this.gestaoPcaService.getPCA().id, 11).subscribe(data => {

      let titulo = "NÃO SE APLICA";
      let modal = this.modalCtrl.create(ModalNaoSeAplicaPage,
        {
          titulo: titulo,
          moduloPca: data,
          IdProcesso: data.moduloPca,
          tipoAnalise: 0,
          jurisdicionado: this.isJurisdicionado,
          isCGE: this.isCGE,
          origemArquivo: "NA",
          origemFilter: 'PESSOAL',
          tipoEntidadeExercicio: 0,
          tipoDocumento: 0
        });
      modal.onDidDismiss(retornoModal => {
        this.carregarDados();
        if (retornoModal && retornoModal.flag) {
        }
      });

      modal.present();

    }, error => {
      console.log("erro ao carregar modulo pca: " + error);
    });

  }

  naoSeAplicaAnalise(item) {

    this.gestaoPcaService.obterModuloAnalise(item.idModuloAnalise).subscribe(data => {

      let titulo = "NÃO SE APLICA";
      let modal = this.modalCtrl.create(ModalNaoSeAplicaPage,
        {
          titulo: titulo,
          moduloAnalise: data,
          IdProcesso: data.moduloAnalise,
          tipoAnalise: 0,
          jurisdicionado: this.isJurisdicionado,
          isCGE: this.isCGE,
          origemArquivo: "NA",
          origemFilter: 'PESSOAL',
          tipoEntidadeExercicio: 0,
          tipoDocumento: 0
        });
      modal.onDidDismiss(retornoModal => {
        this.carregarDados();
        if (retornoModal && retornoModal.flag) {
        }
      });

      modal.present();

    }, error => {
      console.log("erro ao carregar modulo pca: " + error);
    });

  }

  previsualizarCertificado() {

    let modal = this.modalCtrl.create(ModalPreVisualizarPessoalPage, {});
    modal.onDidDismiss(retornoModal => {
      //retorno da modal
    });
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/pessoal/resumo-analise/resumo-analise.ts